import { createFileRoute } from '@tanstack/react-router'

import { useBranchesQuery } from '../../api/branches/api'

export const Route = createFileRoute('/app/branches')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data } = useBranchesQuery()
  return (
    <div>
      <h1>Branches</h1>
      <ul>
        {data?.items.map((branch) => (
          <li key={branch.id}>{branch.name}</li>
        ))}
      </ul>
    </div>
  )
}
